import React from 'react';
import styled from 'react-emotion';
import Typography from '@material-ui/core/Typography';
import theme from '@ublend-npm/aulaui-next-web/themes/default';

export const Container = styled('div')`
  position: absolute;
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
  background-color: ${theme.color.white};
`;

// 20px = height of back button
export const FlexWrapper = styled('div')`
  height: calc(100% - 20px);
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const ContentContainer = styled('div')`
  height: calc(100% - 155px);
  padding: 18px 56px 0px 56px;
  box-sizing: border-box;
  width: 1000px;
`;

export const Title = styled(({ children, ...props }) => (
  <Typography variant="h2" gutterBottom {...props}>
    {children}
  </Typography>
))`
  display: inline-block;
  margin-bottom: ${theme.spacing.medium};
  font-size: 24px;
  font-weight: ${theme.font.weight.semiBold};
  line-height: ${theme.font.lineHeight.headline};
  font-family: ${theme.font.family.workSans};
`;

export const ChipsWrapper = styled('div')`
  height: 40px;
  margin-bottom: ${theme.spacing.medium};
`;
